import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { CiStar } from "react-icons/ci";
import { FaStar } from "react-icons/fa";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
const tableHead = ["Call time", "Caller", "Notes", "mark attended", "Actions"];
function unixToIST(unixTimestamp) {
  // Convert seconds to milliseconds
  const date = new Date(unixTimestamp * 1000);

  // Options for IST formatting
  const options = {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  // Format date using Intl API
  const formatter = new Intl.DateTimeFormat("en-IN", options);
  return formatter.format(date);
}

// Output: "12/09/2025, 15:14:57" (example in DD/MM/YYYY, HH:MM:SS IST)

const getBackgroundStyleByDate = (status) => {
  let style = {};
  if (status === 1) {
    style = {
      backgroundColor: "rgb(12, 166, 120,0.1)",
    };
    return style;
  } else if (status === 3) {
    style = {
      backgroundColor: "rgb(245, 159, 0,0.1)",
    };
    return style;
  } else {
    style = {
      backgroundColor: "rgba(255,0,0,0.1)",
    };
    return style;
  }
};

const getFollowupMessage = (list) => {
  if (list[list.length - 1]?.received_by?.[0].name) {
    return `Last connected to ${list[list.length - 1]?.received_by[0].name}`;
  }
  return "N/A";
};
const MyOpDataTable = ({ data = [] }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/my-operator/${id}`);
  };
  const [leads, setLeads] = useState(data);

  const setAttended = (id) => {
    performRequest("PATCH", `/myOp/updateMyOp/${id}`, { attended: true })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "status updated successfully!");
          setLeads((prevLeads) =>
            prevLeads.map((lead) =>
              lead.id === id ? { ...lead, attended: true } : lead
            )
          );
        } else {
          Toast("error", "Error while updating status!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {leads?.map((item, index) => {
            return (
              <tr
                key={item?.id}
                style={
                  item?.createdAt && getBackgroundStyleByDate(item?.status)
                }
              >
                <td>
                  {item?.start_time ? unixToIST(item?.start_time) : "N/A"}
                </td>
                <td style={{ maxWidth: "200px" }}>
                  <span> {item?.duration || "N/A"}</span>
                  <br />
                  <span>{item?.caller_number || "N/A"}</span>
                </td>
                <td>
                  {item?.log_details && item?.log_details?.length > 0
                    ? getFollowupMessage(item?.log_details)
                    : "N/A"}
                </td>
                <td>
                  <FaStar
                    fontSize="24px"
                    color={item?.attended ? "orange" : "grey"}
                    onClick={
                      item?.attended ? undefined : () => setAttended(item?.id)
                    }
                  />
                </td>
                <td>
                  <CustomViewButton onClick={() => goToView(item.id)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MyOpDataTable;
